export default "__VITE_ASSET__29f2f203__"